import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { MyAccountRoutingModule } from "./myaccount.routing.module";
// import { AppCashierComponent } from "./app-cashier/app-cashier.component";
//import { ConfirmIdentityComponent } from "./complete-profile/confirm-identity/confirm-identity.component";
// import { CompleteProfileComponent } from "./complete-profile/complete-profile.component";
import { ProfileSettingsComponent } from "./profile-settings/profile-settings.component";
// import { TransactionComponent } from "./transaction/transaction.component";
// import { UpdateProfileComponent } from "./complete-profile/update-profile/update-profile.component";
// import { ChangePasswordComponent } from "./complete-profile/change-password/change-password.component";
// import { PreferenceCenterComponent } from "./complete-profile/preference-center/preference-center.component";
// import { BetHistoryComponent } from "./bet-history/bet-history.component";
// import { GamingRealityCheckComponent } from "./complete-profile/gaming-reality-check/gaming-reality-check.component";
// import { AwaitingconfirmationComponent } from "./complete-profile/awaitingconfirmation/awaitingconfirmation.component";
// import { ConfirmApprovalComponent } from "./complete-profile/confirm-approval/confirm-approval.component";
import { MyaccountSharedComponent } from './myaccount-shared/myaccount-shared.component';

// import { BlockKycComponent }from "./complete-profile/block-kyc/block-kyc.component";
// import { InitiatedOrApprovedIdentityComponent } from './complete-profile/initiated-or-approved-identity/initiated-or-approved-identity.component';
//import { SourceOfFundsComponent } from './complete-profile/source-of-funds/source-of-funds.component';



@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        //MbscModule,
        MyAccountRoutingModule
    ],
    declarations: [
        //ConfirmIdentityComponent,
        // CompleteProfileComponent,
        ProfileSettingsComponent,
        // TransactionComponent,
        // UpdateProfileComponent,
        // ChangePasswordComponent,
        // BetHistoryComponent,
        // GamingRealityCheckComponent,
        // AwaitingconfirmationComponent,
        // ConfirmApprovalComponent, 
        MyaccountSharedComponent,
        // BlockKycComponent,
        // InitiatedOrApprovedIdentityComponent,
        //SourceOfFundsComponent
    ],
    providers: [
        MyaccountSharedComponent
    ]

})
export class MyAccountModule { }